const routers = [
	{
		path: '/personal_center/park_user',
		name: 'park_user',
		meta: {
			exp: '园区用户',
			requireAuth: true
		},
		component: () => import('@/views/personal_center/park_user/index.vue'),
		redirect: '/personal_center/park_user/user_info',
		children: [
			{
				path: '/personal_center/park_user/user_info',
				name: 'user_info',
				meta: {
					exp: '用户信息',
					requireAuth: true
				},
				component: () => import('@/views/personal_center/park_user/user_info/index.vue')
			},
			{
				path: '/personal_center/park_user/meeting_room_reservation',
				name: 'meeting_room_reservation',
				meta: {
					exp: '会议室预定',
					requireAuth: true
				},
				component: () => import('@/views/personal_center/park_user/meeting_room_reservation/index.vue'),
				redirect: '/personal_center/park_user/meeting_room_reservation/meeting_room_record',
				children: [
					{
						path: '/personal_center/park_user/meeting_room_reservation/meeting_room_record',
						name: 'meeting_room_record',
						meta: {
							exp: '会议室预定-记录列表',
							requireAuth: true
						},
						component: () =>
							import('@/views/personal_center/park_user/meeting_room_reservation/meeting_room_record/index.vue')
					},
					{
						path: '/personal_center/park_user/meeting_room_reservation/meeting_room_record_detail',
						name: 'meeting_room_record_detail',
						meta: {
							exp: '会议室预定-记录详情',
							requireAuth: true
						},
						component: () =>
							import('@/views/personal_center/park_user/meeting_room_reservation/meeting_room_record/detail/index.vue')
					}
				]
			},
			{
				path: '/personal_center/park_user/my_enroll',
				name: 'my_enroll',
				meta: {
					exp: '我的报名',
					requireAuth: true
				},
				component: () => import('@/views/personal_center/park_user/my_enroll/index.vue'),
				redirect: '/personal_center/park_user/my_enroll/my_enroll_record',
				children: [
					{
						path: '/personal_center/park_user/my_enroll/my_enroll_record',
						name: 'my_enroll_record',
						meta: {
							exp: '我的报名',
							requireAuth: true
						},
						component: () =>
							import('@/views/personal_center/park_user/my_enroll/my_enroll_record/index.vue')
					},
					{
						path: '/personal_center/park_user/my_enroll/my_enroll_detail',
						name: 'my_enroll_detail',
						meta: {
							exp: '报名详情',
							requireAuth: true
						},
						component: () =>
							import('@/views/personal_center/park_user/my_enroll/my_enroll_detail/index.vue')
					}
				]
			},
			{
				path: '/personal_center/park_user/visitor_registration',
				name: 'visitor_registration',
				meta: {
					exp: '访客登记',
					requireAuth: true
				},
				component: () => import('@/views/personal_center/park_user/visitor_registration/index.vue'),
				redirect: '/personal_center/park_user/visitor_registration/visitor_my',
				children: [
					{
						path: '/personal_center/park_user/visitor_registration/visitor_my',
						name: 'visitor_my',
						meta: {
							exp: '我的访客',
							requireAuth: true
						},
						component: () =>
							import('@/views/personal_center/park_user/visitor_registration/visitor_my/index.vue')
					},
					{
						path: '/personal_center/park_user/visitor_registration/visitor_invitation',
						name: 'visitor_invitation',
						meta: {
							exp: '我要邀约',
							requireAuth: true
						},
						component: () =>
							import('@/views/personal_center/park_user/visitor_registration/visitor_invitation/index.vue')
					}
				]
			},
			{
				path: '/personal_center/park_user/my_repair',
				name: 'my_repair',
				meta: {
					exp: '我的报修',
					requireAuth: true
				},
				component: () => import('@/views/personal_center/park_user/my_repair/index.vue'),
				redirect: '/personal_center/park_user/my_repair/repair_record',
				children: [
					{
						path: '/personal_center/park_user/my_repair/repair_record',
						name: 'repair_record',
						meta: {
							exp: '报修记录',
							requireAuth: true
						},
						component: () => import('@/views/personal_center/park_user/my_repair/repair_record/index.vue')
					},
					{
						path: '/personal_center/park_user/my_repair/repair_record_detail',
						name: 'repair_record_detail',
						meta: {
							exp: '报修详情',
							requireAuth: true
						},
						component: () =>
							import('@/views/personal_center/park_user/my_repair/repair_record/detail/index.vue')
					},
					{
						path: '/personal_center/park_user/my_repair/apply_repair',
						name: 'apply_repair',
						meta: {
							exp: '申请报修',
							requireAuth: true
						},
						component: () => import('@/views/personal_center/park_user/my_repair/apply_repair/index.vue')
					}
				]
			},
			{
				path: '/personal_center/park_user/my_purchase',
				name: 'my_purchase',
				meta: {
					exp: '我的拼购',
					requireAuth: true
				},
				component: () => import('@/views/personal_center/park_user/my_purchase/index.vue'),
				redirect: '/personal_center/park_user/my_purchase/purchase_record',
				children: [
					{
						path: '/personal_center/park_user/my_purchase/purchase_record',
						name: 'purchase_record',
						meta: {
							exp: '拼购记录',
							requireAuth: true
						},
						component: () =>
							import('@/views/personal_center/park_user/my_purchase/purchase_record/index.vue'),
						redirect: '/personal_center/park_user/my_purchase/purchase_record/my_launch',
						children: [
							{
								path: '/personal_center/park_user/my_purchase/purchase_record/my_launch',
								name: 'my_launch',
								meta: {
									exp: '我的发起',
									requireAuth: true
								},
								component: () =>
									import('@/views/personal_center/park_user/my_purchase/purchase_record/my_launch/index.vue')
							},
							{
								path: '/personal_center/park_user/my_purchase/purchase_record/my_join',
								name: 'my_join',
								meta: {
									exp: '我的参与',
									requireAuth: true
								},
								component: () =>
									import('@/views/personal_center/park_user/my_purchase/purchase_record/my_join/index.vue')
							}
						]
					},
					{
						path: '/personal_center/park_user/my_purchase/launch_purchase',
						name: 'launch_purchase',
						meta: {
							exp: '发起拼购',
							requireAuth: true
						},
						component: () =>
							import('@/views/personal_center/park_user/my_purchase/launch_purchase/index.vue')
					},
					{
						path: '/personal_center/park_user/my_purchase/my_launch/purchase_detail',
						name: 'purchase_detail',
						meta: {
							exp: '拼购详情',
							requireAuth: true
						},
						component: () =>
							import('@/views/personal_center/park_user/my_purchase/purchase_detail/index.vue')
					}
				]
			},
			{
				path: '/personal_center/park_user/my_order',
				name: 'park_user_my_order',
				meta: {
					exp: '我的订单',
					requireAuth: true
				},
				component: () => import('@/views/personal_center/park_user/my_order/index.vue'),
				redirect: '/personal_center/park_user/serviceOrderTwo',
				children: [
					{
						path: '/personal_center/park_user/achievement_order',
						name: '/personal_center/park_user/achievement_order',
						meta: {
							exp: '我的订单-成果对接订单',
							requireAuth: true
						},
						component: () => import('@/views/personal_center/park_user/my_order/achievement/index.vue')
					},
					{
						path: '/personal_center/park_user/serviceOrderTwo',
						name: '/personal_center/park_user/serviceOrderTwo',
						meta: {
							exp: '我的订单-科技服务订单',
							requireAuth: true
						},
						component: () => import('@/views/personal_center/park_user/my_order/serviceOrderTwo/index.vue')
					},

					{
						path: '/personal_center/park_user/school/order',
						name: '/personal_center/park_user/school/order',
						meta: {
							exp: '我的订单-科创培训订单',
							requireAuth: true
						},
						component: () => import('@/views/personal_center/park_user/my_order/school/index.vue')
					}
				]
			},
			{
				path: '/personal_center/park_user/order_details',
				name: 'order_details',
				meta: {
					exp: '我的订单-科技服务订单详情',
					requireAuth: true
				},
				component: () => import('@/views/personal_center/park_user/my_order/detail/index.vue')
			},
			{
				path: '/personal_center/park_user/my_collection',
				name: 'my_collection',
				meta: {
					exp: '我的收藏',
					requireAuth: true
				},
				redirect: '/personal_center/park_user/my_collection/my_collection_CollectionTypeOffice',
				component: () => import('@/views/personal_center/park_user/my_collection/index.vue'),
				children: [
					{
						path: '/personal_center/park_user/my_collection/my_collection_CollectionTypeOffice',
						name: 'my_collection_metting',
						meta: {
							exp: '办公室收藏',
							requireAuth: true
						},
						component: () => import('@/views/personal_center/park_user/my_collection/office/index.vue')
					},
					{
						path: '/personal_center/park_user/my_collection/my_collection_CollectionTypeMeetings',
						name: 'my_collection_CollectionTypeMeetings',
						meta: {
							exp: '会议室收藏',
							requireAuth: true
						},
						component: () => import('@/views/personal_center/park_user/my_collection/meeting/index.vue')
					},
					{
						path: '/personal_center/park_user/my_collection/my_collection_CollectionTypeStation',
						name: 'my_collection_CollectionTypeStation',
						meta: {
							exp: '工位',
							requireAuth: true
						},
						component: () => import('@/views/personal_center/park_user/my_collection/station/index.vue')
					},
					{
						path: '/personal_center/park_user/my_collection/my_collection_CollectionTypeActivity',
						name: 'my_collection_CollectionTypeActivity',
						meta: {
							exp: '活动',
							requireAuth: true
						},
						component: () => import('@/views/personal_center/park_user/my_collection/activity/index.vue')
					},
					{
						path: '/personal_center/park_user/my_collection/my_collection_CollectionTypeGroupBuy',
						name: 'my_collection_CollectionTypeGroupBuy',
						meta: {
							exp: '拼购',
							requireAuth: true
						},
						component: () => import('@/views/personal_center/park_user/my_collection/group_buy/index.vue')
					}
				]
			},
			{
				path: '/personal_center/park_user/employee_certification',
				name: 'employee_certification',
				meta: {
					exp: '员工认证',
					requireAuth: true
				},
				redirect: '/personal_center/park_user/employee_certification/employee_certification_table_list',
				component: () => import('@/views/personal_center/park_user/employee_certification/index.vue'),
				children: [
					{
						path: '/personal_center/park_user/employee_certification/employee_certification_table_list',
						name: 'employee_certification_table_list',
						meta: {
							exp: '员工认证列表',
							requireAuth: true
						},
						component: () =>
							import('@/views/personal_center/park_user/employee_certification/certificaiton_table_list/index.vue')
					},
					{
						path: '/personal_center/park_user/employee_certification/employee_certification_from',
						name: 'employee_certification_from',
						meta: {
							exp: '员工认证表单',
							requireAuth: true
						},
						component: () =>
							import('@/views/personal_center/park_user/employee_certification/certification_from/index.vue')
					},
					{
						path: '/personal_center/park_user/employee_certification/employee_certification_details',
						name: 'employee_certification_details',
						meta: {
							exp: '员工认证详情',
							requireAuth: true
						},
						component: () =>
							import('@/views/personal_center/park_user/employee_certification/certification_details/index.vue')
					}
				]
			},
			{
				path: '/personal_center/park_user/feedback_suggestions',
				name: 'feedback_suggestions',
				meta: {
					exp: '反馈建议',
					requireAuth: true
				},
				component: () => import('@/views/personal_center/park_user/feedback_suggestions/index.vue')
			},
			{
				path: '/personal_center/park_user/customer_center',
				name: 'customer_center',
				meta: {
					exp: '客户中心',
					requireAuth: true
				},
				component: () => import('@/views/personal_center/park_user/customer_center/index.vue')
			},
			{
				path: '/personal_center/park_user/park_notice',
				name: 'park_notice',
				meta: {
					exp: '园区通告',
					requireAuth: true
				},
				component: () => import('@/views/personal_center/park_user/park_notice/index.vue'),
				redirect: '/personal_center/park_user/park_notice/notice_list',
				children: [
					{
						path: '/personal_center/park_user/park_notice/notice_detail',
						name: 'notice_detail',
						meta: {
							exp: '通告详情',
							requireAuth: true
						},
						component: () => import('@/views/personal_center/park_user/park_notice/notice_detail/index.vue')
					},
					{
						path: '/personal_center/park_user/park_notice/notice_list',
						name: 'notice_list',
						meta: {
							exp: '通告列表',
							requireAuth: true
						},
						component: () => import('@/views/personal_center/park_user/park_notice/notice_list/index.vue')
					}
				]
			}
		]
	}
];
export default routers;
